import { defer } from 'react-router-dom'
import type { OrderSummary } from 'types/receipt/model'
import { getPurchaseOrders } from 'client/receipt/receipt.client'

export const isArrayOfOrders = (data: unknown): data is OrderSummary[] => {
  if (!Array.isArray(data)) {
    return false
  }

  return data.every((item) => {
    return (
      item &&
      typeof item === 'object' &&
      'receiptId' in item &&
      'orderId' in item &&
      'provider' in item &&
      'numberSkus' in item &&
      'frozenOrRefrigerated' in item &&
      'documentType' in item
    )
  })
}

export const receiptLoader = async () => {
  const getOrdersPromise = getPurchaseOrders()
  return defer({ orders: getOrdersPromise })
}
